import React from 'react'
import Readmorewords from '../Movie/MoviesList/ReadMoreInfo'

function ListsDynamicReturn(props) {
  const { header, getSrcValue, item } = props
  return (
    <>
      {header === 'dynamicListImage' ? (
        <td>
          {' '}
          <img style={{ height: '5rem', width: '5rem' }} src={getSrcValue()} />{' '}
        </td>
      ) : header === 'movieListImage' ? (
        ''
      ) : header === 'ID' ? (
        ''
      ) : header === 'description_En' || header === 'description_Te' ? (
        <td key={props.key}>
          <p style={{ width: '20rem' }}>
            <Readmorewords text={item[header]} />
          </p>
          {/* <p className='text' key={props.key}>
            {isReadMore ? (
              <div className='lessspace' style={{ width: '24rem' }}>
                {item[header].slice(0, 200)}
              </div>
            ) : (
              <div className='morespace' style={{ width: '24rem' }}>
                {item[header]}
              </div>
            )}
            <span onClick={toggleReadMore} className='read-or-hide'>
              {item[header].length >= 200 ? (
                isReadMore ? (
                  <div>
                    <b>...read more</b>
                  </div>
                ) : (
                  <div>
                    <b>read less</b>
                  </div>
                )
              ) : (
                ''
              )}
            </span>
          </p> */}
        </td>
      ) : (
        <td>{item[header]}</td>
      )}
    </>
  )
}

export default ListsDynamicReturn
